import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive';
import { MaterialClickOutsideDirective } from '@shared/directives/material-click-outside.directive';

@NgModule({
  exports: [ClickOutsideDirective, MaterialClickOutsideDirective],
  declarations: [ClickOutsideDirective, MaterialClickOutsideDirective],
})
export class ClickOutsideModule {}
